'use client';

import { ArrowIconLight, Css } from '@/ui';
import styled from '@emotion/styled';
import { Color } from '../../../styles/Color';
import { theme } from '../../../styles/theme';
import { RouterLink } from '../link/RouterLink';

interface IViewButtonProps {
	label: string;
	href: string;
}

export default function ViewButton({ label, href }: IViewButtonProps) {
	return (
		<ViewButtonWrap href={href}>
			<ViewButtonLabel>{label}</ViewButtonLabel>
			<IconWrapper>
				<ArrowIconLight />
			</IconWrapper>
		</ViewButtonWrap>
	);
}

const IconWrapper = styled.div`
	border-radius: ${Css.pxToRem(8)};
	padding: ${Css.pxToRem(8)};
	background: ${Color.PrimaryBlue};
	color: ${Color.PrimaryWhite};
	transition: background 0.2s ease;

	svg path {
		fill: currentColor;
	}
`;

const ViewButtonWrap = styled(RouterLink)`
	display: flex;
	gap: ${Css.pxToRem(8)};
	align-items: center;
	text-decoration: none;

	&:hover ${IconWrapper} {
		background: ${theme.button?.primary?.hover?.background};
		color: ${theme.button?.primary?.hover?.font?.color};
	}
	&:focus ${IconWrapper} {
		background: ${theme.button?.primary?.focus?.background};
		color: ${theme.button?.primary?.focus?.font?.color};
	}
`;

const ViewButtonLabel = styled.small`
	font-weight: 700;
	letter-spacing: ${Css.pxToRem(0.84)};
	color: ${Color.PrimaryBlue};
	cursor: pointer;
`;
